const menu = [
  {
    code: '0000',
    name: 'dashboard',
    icon: 'board',
    route: 'Dashboard',
  },
  {
    code: '0010',
    name: 'customers',
    icon: 'users',
    route: 'Customers',
  },
  {
    code: '0020',
    name: 'products',
    icon: 'menu2',
    route: 'Products',
  },
  // {
  //   code: '0031',
  //   name: 'insertOrders',
  //   icon: 'gear',
  //   route: 'InsertOrders',
  // },
  {
    code: '0030',
    name: 'salesStatistics',
    icon: 'stats',
    route: 'StatisticsTemplates',
    routeParams: { type: 'sales' },
    isStatistics: true,
  },
  {
    code: '0032',
    name: 'purchasesStatistics',
    icon: 'stats',
    route: 'StatisticsTemplates',
    routeParams: { type: 'purchases' },
    isStatistics: true,
  },
  {
    code: '0039',
    name: 'stockStatistics',
    icon: 'stats',
    route: 'StatisticsTemplates',
    routeParams: { type: 'stock' },
    isStatistics: true,
  },
  {
    code: '0033',
    name: 'mixStatistics',
    icon: 'stats',
    route: 'StatisticsTemplates',
    routeParams: { type: 'mix' },
    isStatistics: true,
  },
  {
    code: '0031',
    name: 'customerBackorderStatistics',
    icon: 'stats',
    route: 'StatisticsTemplates',
    routeParams: { type: 'customer-backorder' },
    isStatistics: true,
  },
  {
    code: '0035',
    name: 'supplierBackorderStatistics',
    icon: 'stats',
    route: 'StatisticsTemplates',
    routeParams: { type: 'supplier-backorder' },
    isStatistics: true,
  },
  {
    code: '0034',
    name: 'offersAnalysisStatistics',
    icon: 'stats',
    route: 'StatisticsTemplates',
    routeParams: { type: 'offers-analysis' },
    isStatistics: true,
  },
  {
    code: '0036',
    name: 'ordersAnalysisStatistics',
    icon: 'stats',
    route: 'StatisticsTemplates',
    routeParams: { type: 'orders-analysis' },
    isStatistics: true,
  },
  // {
  //   code: '0040',
  //   name: 'commissions',
  //   route: 'Commissions',
  //   icon: 'money2',
  // },
  // {
  //   code: '0050',
  //   name: 'revenue',
  //   route: 'Revenue',
  //   icon: 'dollar',
  // },
  {
    code: '0061',
    name: 'insertedOffers',
    icon: 'doc-xc',
    route: 'InsertedOffers',
  },
  {
    code: '0060',
    name: 'insertedOrders',
    icon: 'doc-oc',
    route: 'InsertedOrders',
  },
  {
    code: '0062',
    name: 'insertedBills',
    icon: 'doc-bl',
    route: 'InsertedBills',
  },
  {
    code: '0070',
    name: 'recommendedActivities',
    icon: 'tasks',
    route: 'Activities',
  },
  {
    code: '0071',
    name: 'openedTasks',
    icon: 'watch',
    route: 'Tasks',
  },
  {
    code: '0072',
    name: 'tagsManagement',
    icon: 'tags',
    route: 'Tags',
  },
  {
    code: '0080',
    name: 'calendarEvents',
    icon: 'calendar',
    route: 'CalendarEvents',
  },
  // {
  //   name: 'items',
  //   icon: 'menu2',
  //   route: 'Items',
  // },
  // {
  //   name: 'tools',
  //   icon: 'gear',
  //   route: 'Tools',
  // },
  {
    name: 'logout',
    icon: 'exit',
    label: 'Logout',
    action: 'logout',
    static: true,
  },

];

export default menu;
